<template>
  <div class="lead">
    <img
      class="leadbg"
      src="../assets/lead-bg.jpg"
    >
    <div class="inner">
      <div class="headlinecont">
        <div class="textcont">
          <img
            src="../assets/headline.png"
            alt="Barber Shop Körkép - A Hungária támogatásával"
          >
        </div>
      </div>
      <div class="articles">
        <article>
          <router-link
            class="next"
            to="../deak-gergely"
          ><img
              class="artthumb"
              src="../assets/article/Deak_580x440.png"
              alt=""
            ></router-link>
          <div class="text">
            <div class="personname">Deák Gergely</div>
            <p>Így lett Gergő az első pesti borbély két éve, amikor már javában
              dübörgött a barber őrület.</p>
            <router-link
              class="next"
              to="../deak-gergely"
            > <img
                class="arrow"
                src="../assets/arrow-r.svg"
                alt="->"
              >Tovább a cikkhez</router-link>
          </div>
        </article>
        <article>
          <router-link
            class="next"
            to="../csorbics-benjamin"
          ><img
              class="artthumb"
              src="../assets/article/Csorbics_580x440.png"
              alt=""
            ></router-link>
          <div class="text">
            <div class="personname">Csorbics Benjamin</div>
            <p>„Elsőre sikerült egy elképesztően jó csapatot összehoznunk, ami jelenleg
              4 borbélyból, 3 tanulóból és egy tetováló művészből áll...”</p>
            <router-link
              class="next"
              to="../csorbics-benjamin"
            > <img
                class="arrow"
                src="../assets/arrow-r.svg"
                alt="->"
              >Tovább a cikkhez</router-link>
          </div>
        </article>
        <article>
          <router-link
            class="next"
            to="../suto-laszlo"
          ><img
              class="artthumb"
              src="../assets/article/Suto_580x440.png"
              alt=""
            ></router-link>
          <div class="text">
            <div class="personname">Sütő László</div>
            <p>„Sikerült még az egész »borbély sztorit« az elején elkapni azzal,<br>
              hogy náluk kezdtem el dolgozni.”</p>
            <router-link
              class="next"
              to="../suto-laszlo"
            > <img
                class="arrow"
                src="../assets/arrow-r.svg"
                alt="->"
              >Tovább a cikkhez</router-link>
          </div>
        </article>
      </div>
      <h1>Barber Shop körkép</h1>
      <div class="intro">
        Borbélyhoz járni világnézet.<br>
        A férfiaknak is van igényük a szépítkezésre, és ez még csak nem is napjaink hóbortja.<br>
        Igaz Magyarországra, alig néhány éve törtek be a borbély üzletek.<br>
        Ez a kis válogatás szubjektív. És nem is teljes. De igyekeztünk a
        legjobbakat összeszedni ebben a listában.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeadComponent',
  props: {

  },
};
</script>

<style scoped lang="css">
h1 {
  font-family: "Blacksword";
  font-size: 60px;
  text-align: center;
  color: #d13138;
  font-weight: 400;
  margin: 50px 0 25px 0;
  line-height: 1;
}
.intro {
  text-align: center;
  margin-bottom: 30px;
  line-height: 2;
  font-size: 16px;
  font-family: "Gotham Book";
}
.personname {
  font-size: 24px;
  font-weight: 900;
  margin: 15px 0;
}
.lead {
  position: relative;
}
.leadbg {
  width: 100%;
  height: auto;
}
.articles {
  flex-wrap: wrap;
  margin: -132px auto 40px auto;
  display: flex;
  justify-content: center;
}
article {
  width: 290px;
  margin: 10px 20px;
  color: #272727;
}
article a {
  text-decoration: none;
}
.artthumb {
  width: 100%;
  height: auto;
}
.arrow {
  width: 15px;
  height: auto;
  margin-right: 15px;
}
.text {
  padding: 0 10px;
}
.next {
  text-decoration: none;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #272727;
  font-weight: 500;
}
p {
  font-size: 16px;
  font-family: "Gotham Book";
}
.headlinecont {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: auto;
  display: -ms-grid;
  -ms-grid-columns: 50% 50%;
  -ms-grid-rows: auto;
  position: absolute;
  top: 80px;
  width: 100%;
  max-width: 1250px;
}
.textcont {
  grid-column: 2/3;
  grid-row: 1/2;
  -ms-grid-column: 2;
  -ms-grid-row: 1;
}
.textcont img {
  width: 78%;
  margin: 0 auto;
  display: block;
}
@media screen and (max-width: 1366px) {
  .headlinecont {
    top: 40px;
  }
}
@media screen and (max-width: 1310px) {
  .headlinecont {
    max-width: calc(100% - 60px);
  }
  .headlinecont {
    top: 30px;
  }
}
@media screen and (max-width: 1190px) {
  .headlinecont {
    top: 70px;
  }
  .articles {
    margin: -75px auto 40px auto;
  }
}
@media screen and (max-width: 1120px) {
  .headlinecont {
    top: 60px;
  }
  .articles {
    margin: -45px auto 40px auto;
  }
  article {
    margin: 30px;
  }
}
@media screen and (max-width: 910px) {
  .articles {
    margin: 10px auto 40px auto;
  }
  .headlinecont {
    top: 80px;
  }
}
@media screen and (max-width: 810px) {
}
@media screen and (max-width: 767px) {
  .lead {
    overflow: hidden;
  }
  .headlinecont {
    top: 40px;
    grid-template-columns: 30% 70%;
    -ms-grid-columns: 30% 70%;
  }
  .leadbg {
    width: initial;
    height: 290px;
    left: -5%;
    position: relative;
  }
}
@media screen and (max-width: 640px) {
  .headlinecont {
    top: 10vw;
  }
  .leadbg {
    left: -20%;
  }
}
@media screen and (max-width: 530px) {
}
@media screen and (max-width: 480px) {
  .headlinecont {
    grid-template-columns: 20% 80%;
    -ms-grid-columns: 20% 80%;
  }
  .textcont img {
    width: 90%;
  }
}
</style>
